import { SHORT_ANSWERS } from "@/data/short-answers";

// "The short answer" box: the page's main question as a heading with a plain
// answer directly under it, plus the law it relies on. Renders nothing for
// pages without an entry in data/short-answers.js.
export default function ShortAnswer({ path, className = "" }) {
  const entry = SHORT_ANSWERS[path];
  if (!entry) return null;
  return (
    <section
      data-testid="short-answer"
      aria-labelledby="short-answer-question"
      className={`border-l-4 border-pink bg-pink/10 p-6 sm:p-7 ${className}`}
    >
      <p className="eyebrow text-ink/55">The short answer</p>
      <h2 id="short-answer-question" className="mt-3 font-display text-xl sm:text-2xl font-semibold tracking-tight text-ink">
        {entry.question}
      </h2>
      <div className="mt-4 space-y-3 text-base leading-relaxed text-ink/80">
        {entry.answer.map((para) => (
          <p key={para}>{para}</p>
        ))}
      </div>
      {entry.sources?.length > 0 && (
        <p className="mt-4 text-xs leading-relaxed text-ink/55">
          <span className="font-semibold">Law: </span>
          {entry.sources.map((s, i) => (
            <span key={s.url}>
              {i > 0 && "; "}
              <a href={s.url} target="_blank" rel="noopener noreferrer" className="underline decoration-pink underline-offset-2 hover:text-ink">
                {s.label}
              </a>
            </span>
          ))}
        </p>
      )}
    </section>
  );
}
